import { useInfiniteQuery } from '@tanstack/react-query';
import { getArticles } from '@/lib/articlesApi';
import { InterviewMapperService } from '@/services/interview/management/base/interviewMapperService';
import { Interview } from '@/types/interview';

const ITEMS_PER_PAGE = 20;

export const useInfiniteInterviews = () => {
  return useInfiniteQuery({
    queryKey: ['publishedInterviews', 'infinite'],
    queryFn: async ({ pageParam = 0 }) => {
      const data = await getArticles({ 
        limit: ITEMS_PER_PAGE, 
        offset: pageParam 
      });
      
      if (!data || !Array.isArray(data)) {
        return [];
      }
      
      const mapped = data.map(interview => 
        InterviewMapperService.mapDatabaseInterviewToModel(interview as any)
      );
      
      // Debug logging to verify sourceArticles are mapped
      if (mapped.length > 0) {
        console.log('[useInfiniteInterviews] First article sourceArticles:', mapped[0]?.sourceArticles);
      }
      
      return mapped;
    },
    getNextPageParam: (lastPage, allPages) => {
      // If we got a full page, there might be more
      if (lastPage.length === ITEMS_PER_PAGE) {
        return allPages.length * ITEMS_PER_PAGE;
      }
      // If we got less than a full page, we've reached the end
      return undefined;
    },
    initialPageParam: 0,
    staleTime: 60000,
    refetchOnWindowFocus: false,
  });
};
